import { useSearchPageIsLoggedOutDiscoverPage } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageMaybeRenderSEMTextBlock/__internal__/useSearchPageIsLoggedOutDiscoverPage";
import React, { lazy, Suspense } from "react";

export const MaybeRenderSEMTextBlock = () => {
  const isLoggedOutDiscoverPage = useSearchPageIsLoggedOutDiscoverPage();

  if (isLoggedOutDiscoverPage) {
    return <RenderSEMTextBlock />;
  }

  return null;
};

const RenderSEMTextBlock = React.memo(() => {
  return (
    <Suspense fallback={null}>
      <LazySEMTextBlock />
    </Suspense>
  );
});

const LazySEMTextBlock = lazy(() =>
  import(
    /* webpackChunkName: "logged-out-discover-page-sem-text-block" */ "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageMaybeRenderSEMTextBlock/__internal__/SEMTextBlock"
  ).then((m) => ({ default: m.SEMTextBlock }))
);
